export default function PlayerCard({ spieler }) {
  return (
    <div className="bg-white border border-black/5 shadow-sm overflow-hidden group">
      <div className="aspect-[3/4] bg-dark/5 overflow-hidden">
        {spieler.foto ? (
          <img
            src={spieler.foto}
            alt={spieler.name}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-dark/15">
            <svg className="h-16 w-16" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
            </svg>
          </div>
        )}
      </div>
      <div className="px-3 py-3 text-center border-t border-black/5">
        <p className="font-bold text-sm uppercase truncate">{spieler.name}</p>
      </div>
    </div>
  );
}
